<template>
    <div>
        <div class="form-row-flex">
            <span>
                {{ __('Password') }}
            </span>
            <FormInput
                :class="{'is-danger': errors.has('password')}"
                name="password"
                ref="password"
                type="password"
                v-model="user.oldPassword"
                v-validate="'required|min:6'"
            />
        </div>

        <div class="form-row-flex">
            <span>
                {{ __('New password') }}
            </span>
            <FormInput
                :class="{'is-danger': errors.has('password')}"
                name="password"
                ref="password"
                type="password"
                v-model="user.password"
                v-validate="'required|min:6'"
            />
        </div>

        <div class="form-row-flex">
            <span>
                {{ __('Confirm new password') }}
            </span>
              <FormInput
                  :class="{'is-danger': errors.has('password_confirmation')}"
                  data-vv-as="password"
                  name="password_confirmation"
                  type="password"
                  v-model="user.password2"
                  v-validate="'required|confirmed:password'"
              />
        </div>

        <RequestButton
            :on-click="change"
            class="btn btn-md btn-primary float-right"
        >
            {{ __('Change password') }}
        </RequestButton>
    </div>
</template>

<script>
import { __ } from '../../translations/localization'

export default {
  name: 'ProfilePasswordChange',

  data () {
    return {
      user: {
        oldPassword: null,
        password: null,
        password2: null
      }
    }
  },

  methods: {
    change () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          return this.$api.auth.changePassword(this.user)
            .then(() => {
              this.$toaster.success(__('Password successfully changed!'))
              this.user = {}
              this.$nextTick(() => this.$validator.reset())
            })
            .catch((response) => {
              this.setErrorsFromResponse(response)
            })
        }
      })
    }
  }
}
</script>
